module.exports = __webpack_public_path__ + "static/img/app_coder.3cd38a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_coder.png
// module id = rfEw
// module chunks = 5